// Загружает Roboto-Regular (с кириллицей) в jsPDF как шрифт по умолчанию.
// Возвращает Promise<jsPDF>, с которым можно сразу работать: doc.setFont('Roboto')

let cachedBase64 = null;

async function loadRobotoBase64() {
  if (cachedBase64) return cachedBase64;
  const res = await fetch('/fonts/Roboto-Regular.ttf');
  if (!res.ok) throw new Error(`Не удалось загрузить шрифт: ${res.status}`);
  const buf = await res.arrayBuffer();
  // Преобразование ArrayBuffer → base64 по частям (без переполнения стека)
  const bytes = new Uint8Array(buf);
  let binary = '';
  const chunk = 0x8000;
  for (let i = 0; i < bytes.length; i += chunk) {
    binary += String.fromCharCode.apply(null, bytes.subarray(i, i + chunk));
  }
  cachedBase64 = btoa(binary);
  return cachedBase64;
}

export async function installCyrillicFont(doc) {
  const base64 = await loadRobotoBase64();
  doc.addFileToVFS('Roboto-Regular.ttf', base64);
  doc.addFont('Roboto-Regular.ttf', 'Roboto', 'normal');
  doc.addFont('Roboto-Regular.ttf', 'Roboto', 'bold');
  doc.setFont('Roboto', 'normal');
  return doc;
}
